// Error helpers for code outside src/apis/, which may not import axios
// directly (eslint.strict.config.mjs): requests go through the API functions
// here, and callers only need to recognise what those functions reject with.
import axios from 'axios';

export { AxiosError, AxiosHeaders } from 'axios';

/** True when `error` came from an API request (an AxiosError). */
export const isApiError = axios.isAxiosError;

/** True when the request was cancelled (AbortController or CancelToken). */
export const isRequestCancelled = axios.isCancel;
